import React from "react"
import SiteSidebar from "../components/SiteSidebar"
import MasterLayout from "./master"


class InsetPageLayout extends React.Component {
  render() {
    const siteMetadata = this.props.data.site

    return (
      <MasterLayout {...this.props}>
        <section className="hero is-secondary is-fullheight">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                Engularity
              </h1>
              <h2 className="subtitle">
                Eng[ineering with Mod]ularity.
              </h2>
            </div>
          </div>
        </section>
        <div className="PageTemplate section container is-primary">
          <div className="columns">
            <div className="column is-one-quarter">
              <SiteSidebar {...this.props} />
            </div>
            <div className="column">
              {this.props.children()}
            </div>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

export default InsetPageLayout

export const pageQuery = graphql`
query InsetLayoutBySlug {
  site {
    siteMetadata {
      siteTitle
      siteDescr
      siteAuthor
      siteEmail
      siteTwitterUrl
      siteTwitterPretty
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/insetPage.js